import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faSignOutAlt, faUser } from '@fortawesome/free-solid-svg-icons';

const Header = () => {
  const auth = useSelector((state) => state.auth);
  const location = useLocation();
  const page_location = location.pathname.split('/')[1];
  const navigate = useNavigate();
  useEffect(() => {
    if (page_location == "user") {
      if (!auth) {
        navigate('/logout');
      }

      let currentDate = new Date();
      if (auth.user && auth.user.exp * 1000 < currentDate.getTime()) {
        navigate("/logout");
      }
    }
    // Check JWT expiry
  });
  let page_name = page_location;
  if (auth && page_name == "user") {
    page_name = location.pathname.split('/')[2];
  }
  page_name = page_name ? page_name.replaceAll("-", "_") : "home";
  let page = {};
  page[page_name] = "active";

  const ProfileIcon = () => {
    let pi = <FontAwesomeIcon icon={faUser} className={"text-info pt-3"} />
    // if(auth.user.gender) {
    //   pi = <img src={process.env.PUBLIC_URL+"/images/user/profile/"+auth.user.gender+".png"} alt={auth.user.fullname} width={50} />
    // }
    return pi;
  }
  return (
    <>
      <header id="header-part">
        {/* {(!auth || page_location != "user") &&
          <div className="header-top">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-8">
                  <div className="header-contact text-lg-left text-center">
                    <ul>
                      <li><span><i className="fa fa-phone"></i> +91-11-4044-5999</span></li>
                      <li><span><i className="fa fa-envelope-o"></i> fellowship@cdri.world</span></li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="header-contact text-lg-right text-center">
                    <ul>
                      <li><span><Link to={"/login"} className="btn btn-danger">Login</Link></span></li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="header-social text-lg-right text-center">
                    <ul>
                      <li><a href="https://www.facebook.com/Coalition-for-Disaster-Resilient-Infrastructure-109999954712859" target={"blank"}><i className="fa fa-facebook-f"></i></a></li>
                      <li><a href="https://twitter.com/cdri_world"><i className="fa fa-twitter" target={"blank"}></i></a></li>
                      <li><a href="https://www.linkedin.com/company/coalition-for-diasaster-resilient-infrastructure/" target={"blank"}><i className="fa fa-linkedin"></i></a></li>
                      <li><a href="https://www.youtube.com/channel/UCh44NgGlVNdx0rtwel9OFvA" target={"blank"}><i className="fa fa-youtube"></i></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        } */}

        <div className="navigation navigation-2 border-bottom">
          <div className="container">
            <div className="row no-gutters">
              <div className="col-12">
                <nav className="navbar navbar-expand-lg">
                  {(auth && page_location == "user") ?
                    <a href="/" target="_blank" className="navbar-brand">
                      <img src={process.env.PUBLIC_URL + "/images/cdri-logo.png"} alt="Logo" width={150} />
                    </a> :
                    <a href="https://cdri.world/fellowship" target="_blank" className="navbar-brand">
                      <img src={process.env.PUBLIC_URL + "/images/cdri-logo.png"} alt="Logo" width={150} />
                    </a>
                  }
                  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </button>

                  <div className="collapse navbar-collapse sub-menu-bar" id="navbarSupportedContent">
                    {(auth && page_location == "user") ?
                      <ul className="navbar-nav ml-auto">
                        {page.home != "active" &&
                          <li className="nav-item">
                            <Link to={"/user/home"} className={page.home}>
                              <FontAwesomeIcon icon={faHome} title="Home"></FontAwesomeIcon>
                            </Link>
                          </li>
                        }
                        {/* <li className="nav-item">
                          <Link to={"/user/proposals"} className={page.proposals}>Proposals</Link>
                        </li> */}
                        <li className="nav-item">
                          <Link to={"/user/home"} className="mr-2">{auth.user.firstname} {auth.user.lastname}</Link>
                          <ProfileIcon />
                          <ul className="sub-menu dropdown-menu-right">
                            {/* <li><Link to={"user/home?innerpage=tl"}><FontAwesomeIcon icon={faUser}></FontAwesomeIcon> Team Profile</Link></li> */}
                            <li><Link to={"/logout"}><FontAwesomeIcon icon={faSignOutAlt}></FontAwesomeIcon> Logout</Link></li>
                          </ul>
                        </li>

                      </ul> :
                      <ul className="navbar-nav ml-auto">
                        {/* <li className="nav-item">
                          <Link to={"/fellows-2023-2024"} className="active badge badge-danger p-2 m-4 text-white">Call For Applications For Cohort 2023-24</Link>
                        </li>
                        <li className="nav-item">
                          <Link to={"/"} className={page.home}>Home</Link>
                        </li>
                        <li className="nav-item">
                          <Link to={"#"} className={page.about}>About</Link>
                          <ul className="sub-menu">
                            <li><Link to={"/fellowship-programme"} className={page.fellowship_programme}>CDRI Fellowship Programme</Link></li>
                            <li><Link to={"/scope"} className={page.scope}>Scope</Link></li>
                            <li><Link to={"/salient-features"} className={page.salient_features}>Salient Features</Link></li>
                            <li><Link to={"international-jury"} className={page.international_jury}>International Jury</Link></li>
                          </ul>
                        </li>
                        <li className="nav-item">
                          <Link to={"#"}>CDRI Fellows</Link>
                          <ul className="sub-menu">
                            <li><Link to={"fellows-2023-2024"} className={page.fellows_2023_2024}>Fellows 2023-2024</Link></li>
                            <li><Link to={"fellows-2022-2023"} className={page.fellows_2022_2023}>Fellows 2022-2023</Link></li>
                            <li><Link to={"fellows-2021-2022"} className={page.fellows_2021_2022}>Fellows 2021-2022</Link></li>
                          </ul>
                        </li>
                        <li className="nav-item">
                          <Link to={"/faqs"} className={page.faqs}>FAQs</Link>
                          <Link to={"/"}>Support</Link>
                          <ul className="sub-menu">
                            <li><Link to={"/important-dates"} className={page.important_dates}>Important Dates</Link></li>
                            <li><Link to={"/selection-process"} className={page.selection_process}>Selection Process</Link></li>
                            <li><Link to={"/instructions"} className={page.instructions}>Instructions</Link></li>
                            <li><Link to={"/faqs"} className={page.faqs}>FAQs</Link></li>
                          </ul>
                        </li> */}
                      </ul>
                    }
                  </div>
                </nav> {/* nav */}
              </div>
              {/* <div className="col-lg-1 col-md-2 col-sm-3 col-3">
                <div className="right-icon text-right">
                  <ul>
                    <li><Link to="#" id="search"><i className="fa fa-search"></i></Link></li>
                    <li><Link to="#"><i className="fa fa-shopping-bag"></i><span>0</span></Link></li>
                  </ul>
                </div>
              </div> */}
            </div> {/* row */}
          </div> {/* container */}
        </div>

      </header>
    </>
  );
};

export default Header;